import type { VerticalVideoCardProps } from '@ahc-digital/component-library';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps } from 'src/shared/shared.types';

export type C42VerticalVideoCardProps = RenderingProps<C42VerticalVideoCardFields> &
  Pick<VerticalVideoCardProps, 'hasShadow' | 'isActive' | 'onReady'>;

export type C42VerticalVideoCardFields = {
  YouTubeID?: Field<string>;
};
